import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two all-projects" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }
const _hoisted_6 = { class: "text-body" }
const _hoisted_7 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "ms-m-15" }
const _hoisted_10 = { class: "text-body" }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = { class: "text-body" }
const _hoisted_13 = { class: "d-flex align-items-center gap-1" }
const _hoisted_14 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_15 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_16 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_17 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_18 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_19 = { class: "material-symbols-outlined fs-16 text-danger" }
const _hoisted_20 = { class: "p-4 pt-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"p-4\"><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\"><h3 class=\"mb-0\">My Projects</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>This Week</option><option value=\"1\">This Month</option><option value=\"2\">This Year</option></select></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "ID"),
                _createElementVNode("th", { scope: "col" }, "Project Name"),
                _createElementVNode("th", { scope: "col" }, "Client"),
                _createElementVNode("th", { scope: "col" }, "Assignees"),
                _createElementVNode("th", { scope: "col" }, "Budget"),
                _createElementVNode("th", { scope: "col" }, "Start Date"),
                _createElementVNode("th", { scope: "col" }, "End Date"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.slice(0, 5), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(item.id), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, { to: "/project-management/project-overview" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.projectName), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.client), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("ul", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.assignees.images, (userImg) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "ms-m-15",
                          key: userImg.id
                        }, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: userImg.image,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, 8, _hoisted_8)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128)),
                      _createElementVNode("li", _hoisted_9, [
                        _createVNode(_component_RouterLink, {
                          to: "/users/users-list",
                          class: "wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.assignees.number), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_10, "$" + _toDisplayString(item.budget), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.startDate), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.endDate), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                    }, _toDisplayString(item.status), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", _hoisted_14, [
                        _createElementVNode("i", _hoisted_15, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_16, [
                        _createElementVNode("i", _hoisted_17, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_18, [
                        _createElementVNode("i", _hoisted_19, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_Pagination, {
            items: "05",
            total: _ctx.items.length
          }, null, 8, ["total"])
        ])
      ])
    ])
  ]))
}